import { EditOutlined } from '@ant-design/icons';
//DeleteFilled ,Popconfirm
import { Button, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import dayjs from 'dayjs';
import { MatrialFilterFormValuesPaginated } from 'features/master/components/master-filter-form';
//import { useCreateStation } from 'features/master/use-cases/create-station';
import { Dispatch, Fragment, SetStateAction } from 'react';
import { SideBarMenus } from 'routes/constants';
import { User } from 'types';
import { Matrial } from 'types/matrial';
import { HasPermission } from 'utils/CheckPermissions';

type MatrialTableProps = {
  ismasterListLoading: boolean;
  masterList: User[];
  itemsCount: number;
  tableParams: MatrialFilterFormValuesPaginated;
  updateParams: Dispatch<SetStateAction<MatrialFilterFormValuesPaginated>>;
  setUserEditData: any;
  setShowAppUserModal: any;
  onRefresh :  () => void ;
  isFetching : boolean ;
};

export const StationTable = ({
  masterList,
  ismasterListLoading,
  itemsCount,
  tableParams,
  updateParams,
  setUserEditData,
  setShowAppUserModal,
  onRefresh ,
  isFetching
}: MatrialTableProps) => {
  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<Matrial> | SorterResult<Matrial>[]
  ) => {
    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      order_by: Array.isArray(sorter)
        ? undefined
        : sorter.order === 'ascend'
        ? 'name'
        : '-name',
    });
  };

 
  //const { mutate } = useCreateStation();

  return (
    <>
      <StyledTableWrapper>
        <StyledTableHeader>
          <RecordCountBadge text={'Station'} count={itemsCount} />
           <Button
          type="link"                // 👈 makes it look like blue text
          onClick={onRefresh}
          loading={ismasterListLoading}
          style={{ padding: 0, marginBottom: 16 }}
        >
          Refresh Data
        </Button>
        </StyledTableHeader>

        <Table<Matrial>
          loading={(ismasterListLoading || isFetching) && { indicator: <TableLoader /> }}
          dataSource={masterList}
          rowKey="id"
          onChange={handleTableChange}
          pagination={{
            current: tableParams.page,
            defaultPageSize: tableParams.size,
            total: itemsCount,
          }}
        >
          <Column<Matrial> title={'Title'} dataIndex={'title'} />
          <Column<Matrial> title={'Description'} dataIndex={'description'} />
          <Column<Matrial>
            title={'Created On'}
            dataIndex={'createdOn'}
            render={(item) => (
              <span>{dayjs(item).format('DD/MM/YYYY')}</span>
            )}
          />
           {/* <Column<Matrial> title={'Is Manual Save'} dataIndex={'isManualSave'} /> */}
          <Column<Matrial>
            title={'Action'}
            render={(item) => {
              return (
                <Fragment>
                        {HasPermission(SideBarMenus.STATIONS, 'edit') ? (
                  <div
                    onClick={() => {
                      setShowAppUserModal(true);
                      setUserEditData(item);
                    }}
                    className="inline-block mr-2 cursor-pointer"
                  >
                    <EditOutlined />
                  </div>):null}
                  {/* <Popconfirm
                    title="Are you sure you want to delete this item?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => {
                      mutate({
                        flag: 'Delete',
                        id: item.id,
                        title:item?.title,
                        description:item?.description,
                        type:item?.type
                      }as any);
                    }}
                  >
                    <div className="inline-block text-red-500 cursor-pointer">
                      <DeleteFilled />
                    </div>
                  </Popconfirm> */}
                </Fragment>
              );
            }}
          />
        </Table>
      </StyledTableWrapper>
    </>
  );
};
